










import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import Form from '@/classes/Form';
import FormsTable from '@/components/FormsTable/FormsTable.vue';

@Component({components: {
        FormsTable
    }
})
export default class AllForms extends Vue {
  get requests(): Form[] {
      return this.$store.getters.getForms;
    }
}
